import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/home';

export default function HotExposesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-500/10 border border-secondary-500/20 text-secondary-400 text-xs font-medium mb-4">
              <i className="ri-fire-line text-sm"></i>
              热门曝光
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50">
              大家都在看的<strong className="text-secondary-500">黑料</strong>
            </h2>
          </div>
        </div>

        {/* Hot Articles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/40 hover:border-secondary-500/30 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={`51黑料网 - ${article.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  title={article.title}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100/90 to-transparent"></div>
                {article.hot && (
                  <span className="absolute top-3 right-3 px-2 py-0.5 rounded text-[10px] font-medium bg-primary-500/90 text-foreground-50 flex items-center gap-1">
                    <i className="ri-fire-line"></i> HOT
                  </span>
                )}
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded text-[10px] font-medium bg-background-50/70 text-foreground-300 backdrop-blur-sm">
                  {article.category}
                </span>
              </div>

              {/* Content */}
              <div className="p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-100 group-hover:text-secondary-400 transition-colors duration-200 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/40">
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-time-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-eye-line"></i>
                    {(article.views / 1000).toFixed(1)}k 阅读
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View More */}
        <div className="mt-10 text-center">
          <Link
            to="/category/insider-reveal"
            className="inline-flex items-center gap-2 px-6 py-3 border border-background-300/60 rounded-full text-sm text-foreground-300 hover:text-foreground-50 hover:border-foreground-300 transition-colors duration-200 cursor-pointer"
          >
            浏览更多曝光内容
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}